import i18n from "../i18n";
import { TIME_FORMATS } from "../modules/constants";

export const getTimeFormatTranslation = (value) => {
  const timeFormatObj = TIME_FORMATS.find(
    (timeFormatObj) => timeFormatObj.id === value
  );
  switch (timeFormatObj?.id) {
    case "12h":
      return i18n.t("appText.timeFormat.12hour");
    case "24h":
      return i18n.t("appText.timeFormat.24hour");
    default:
      return "";
  }
};

const MOMENT_12H_FORMAT = "h:mm A";
const MOMENT_24H_FORMAT = "HH:mm";

export const getTimeFormat = (timeFormat) => {
  switch (timeFormat) {
    case "24h":
      return MOMENT_24H_FORMAT;

    default:
      return MOMENT_12H_FORMAT;
  }
};
